import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import { PatternFormat } from 'react-number-format';
import CreatableSelect from 'react-select/creatable';


const medicationOptions = [
  { value: 'Sertraline', label: 'Sertraline' },
  { value: 'Bupropion', label: 'Bupropion' },
  { value: 'Escitalopram', label: 'Escitalopram' },
  { value: 'Venlafaxine', label: 'Venlafaxine' },
  { value: 'Trazodone', label: 'Trazodone' },
  { value: 'Fluoxetine', label: 'Fluoxetine' },
  { value: 'Paroxetine', label: 'Paroxetine' },
  { value: 'Citalopram', label: 'Citalopram' },
  { value: 'Duloxetine', label: 'Duloxetine' },
  { value: 'Mirtazapine', label: 'Mirtazapine' },
  { value: 'Amitriptyline', label: 'Amitriptyline' },
  { value: 'Nortriptyline', label: 'Nortriptyline' },
  { value: 'Imipramine', label: 'Imipramine' },
  { value: 'Desipramine', label: 'Desipramine' },
  { value: 'Lithium', label: 'Lithium' },
  { value: 'Lamotrigine', label: 'Lamotrigine' },
  { value: 'Valproate', label: 'Valproate' },
  { value: 'Divalproex', label: 'Divalproex' },
  { value: 'Carbamazepine', label: 'Carbamazepine' },
  { value: 'Oxcarbazepine', label: 'Oxcarbazepine' },
  { value: 'Aripiprazole', label: 'Aripiprazole' },
  { value: 'Risperidone', label: 'Risperidone' },
  { value: 'Olanzapine', label: 'Olanzapine' },
  { value: 'Quetiapine', label: 'Quetiapine' },
  { value: 'Ziprasidone', label: 'Ziprasidone' },
  { value: 'Lurasidone', label: 'Lurasidone' },
  { value: 'Clozapine', label: 'Clozapine' },
  { value: 'Haloperidol', label: 'Haloperidol' },
  { value: 'Chlorpromazine', label: 'Chlorpromazine' },
  { value: 'Perphenazine', label: 'Perphenazine' },
  { value: 'Thioridazine', label: 'Thioridazine' },
  { value: 'Buspirone', label: 'Buspirone' },
  { value: 'Hydroxyzine', label: 'Hydroxyzine' },
  { value: 'Propranolol', label: 'Propranolol' },
  { value: 'Clonazepam', label: 'Clonazepam' },
  { value: 'Lorazepam', label: 'Lorazepam' },
  { value: 'Diazepam', label: 'Diazepam' },
  { value: 'Alprazolam', label: 'Alprazolam' },
  { value: 'Temazepam', label: 'Temazepam' },
  { value: 'Zolpidem', label: 'Zolpidem' },
  { value: 'Eszopiclone', label: 'Eszopiclone' },
  { value: 'Trazodone', label: 'Trazodone' },
  { value: 'Modafinil', label: 'Modafinil' },
  { value: 'Atomoxetine', label: 'Atomoxetine' },
  { value: 'Methylphenidate', label: 'Methylphenidate' },
  { value: 'Dexmethylphenidate', label: 'Dexmethylphenidate' },
  { value: 'Amphetamine/Dextroamphetamine', label: 'Amphetamine/Dextroamphetamine' },
  { value: 'Lisdexamfetamine', label: 'Lisdexamfetamine' },
  { value: 'Guanfacine', label: 'Guanfacine' },
  { value: 'Clonidine', label: 'Clonidine' },
];

export default function MedicationRefillPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    nextAppointment: '',
    newAllergy: '',
    newAllergyName: '',
    pharmacy: '',
    pharmacyType: '',
    localPharmacy: '',
    otherLocalPharmacy: '',
    mailOrderPharmacy: '',
    otherMailOrderPharmacy: '',
    pharmacyCrossRoads: '',
    contact: '',
    email: '',
    phone: '',
    voicemail: '',
  });

  const [medications, setMedications] = useState([{ id: 0, name: '', strength: '' }]);
  const [inputValues, setInputValues] = useState({}); // key: med.id, value: input string

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMedicationChange = (index, field, value) => {
    const updated = [...medications];
    updated[index][field] = value;
    setMedications(updated);
  };

  const addMedication = () => {
    if (medications.length < 10) {
      setMedications((prev) => [...prev, { id: Date.now(), name: '', strength: '' }]);
    }
  };

  const removeMedication = (id) => {
    setMedications((prev) => prev.filter((m) => m.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData, medications };
    try {
      const res = await fetch('/api/medication-refill', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        alert('Your refill request has been submitted!');
      } else {
        alert('Something went wrong. Please try again later.');
      }
    } catch (err) {
      console.error('Error submitting refill form:', err);
      alert('Server error. Please try again later.');
    }
  };

  return (
    <>
      <Helmet>
        <title>Home | Redemption Psychiatry</title>
      </Helmet>

      <Header />
      <div className="container py-5" id="content">
        <h2 className="mb-4 text-center">Routine Medication Refill Request Form</h2>
        <p>
          If you need a refill of your current medications before your next appointment, you may use this form to give our
          staff the information they need to process your request as soon as possible during the business day. If you don't
          have a follow-up appointment scheduled, you need to call the office and schedule an appointment before requesting
          any medication refills.
        </p>

        <div className="alert alert-primary">
          <strong>Use of this form does not guarantee you will automatically receive every medication you request, requests are only processed during normal business hours.</strong>
          <br /><br />
          <strong>DO NOT</strong> use this form if:
          <p style={{ marginLeft: '15px' }}>
            A) You suspect a medication is causing side effects and/or wish to ask for dose adjustments. This needs to be discussed with your prescriber or with the Nurse.<br />
            B) You wish to discuss changing to a different medication. This can only be reviewed and approved by your prescriber.<br />
            C) <strong>If you do not have a follow-up appointment already scheduled with your provider</strong>, as we can only provide enough medication until your next appointment.
          </p>
          <strong>If any of these situations apply to you, please contact your provider's office to schedule a follow-up appointment.</strong>

          <div className="row text-center mt-3">
            <div className="col">
              <a className="button blue" href="tel:+14805420202">Gilbert<br /><span>(480) 542-0202</span></a>
            </div>
            <div className="col">
              <a className="button blue" href="tel:+14805420222">Chandler<br /><span>(480) 542-0222</span></a>
            </div>
            <div className="col">
              <a className="button blue" href="tel:+14805421212">Mesa<br /><span>(480) 542-1212</span></a>
            </div>
            <div className="col">
              <a className="button blue" href="tel:+16025603505">Phoenix<br /><span>(602) 560-3505</span></a>
            </div>
          </div>
          <br />
          When this form is completed appropriately, you should receive a call from your pharmacy within 2–5 days to update
          you on the status of refilling your medication. You will only receive a call back from our staff if we have a
          question regarding your submission.
        </div>

        <form onSubmit={handleSubmit}>
          <h3 className="mt-5">Personal Information:</h3>
          <div className="form-row split">
            <div>
              <label>Patient First Name</label>
              <input type="text" name="firstName" value={formData.firstName} onChange={handleInput} placeholder="First Name *" />
            </div>
            <div>
              <label>Patient Last Name</label>
              <input type="text" name="lastName" value={formData.lastName} onChange={handleInput} placeholder="Last Name *" />
            </div>
          </div>
          <div className="form-row split">
            <div>
              <label>Date of Birth</label>
              <input type="date" name="dob" value={formData.dob} onChange={handleInput} />
            </div>
            <div>
              <label>Next Appointment</label>
              <input type="date" name="nextAppointment" value={formData.nextAppointment} onChange={handleInput} />
            </div>
          </div>

          <h3 className="mt-5">New Allergy Information:</h3>
          <div className="form-row">
            <label><input type="radio" name="newAllergy" value="No" checked={formData.newAllergy === 'No'} onChange={handleInput} /> No</label>
            <label><input type="radio" name="newAllergy" value="Yes" checked={formData.newAllergy === 'Yes'} onChange={handleInput} /> Yes</label>
            {formData.newAllergy === 'Yes' && (
              <input type="text" name="newAllergyName" value={formData.newAllergyName} onChange={handleInput} placeholder="Name of new medication allergy *" />
            )}
          </div>

          <h3 className="mt-5">Medication Information:</h3>
          {medications.map((med, index) => (
            <div className="form-row" key={med.id} style={{ border: '1px solid lightgray', padding: '15px', marginBottom: '15px' }}>
              <div style={{ width: '100%', boxShadow: 'none' }}>
                <label>Medication Name</label>
                <CreatableSelect
                  options={medicationOptions}
                  isClearable
                  placeholder="Start typing or enter a new medication..."
                  inputValue={inputValues[med.id] || ''}
                  onInputChange={(value, { action }) => {
                    if (action !== 'input-blur' && action !== 'menu-close') {
                      setInputValues((prev) => ({ ...prev, [med.id]: value }));
                    }
                  }}
                  onChange={(selected) => {
                    const newValue = selected ? selected.value : '';
                    handleMedicationChange(index, 'name', newValue);
                    setInputValues((prev) => ({ ...prev, [med.id]: '' }));
                  }}
                  menuIsOpen={!!inputValues[med.id]} // only open if typing
                  openMenuOnFocus={false}
                />


              </div>
              <div style={{ width: '100%' }}>
                <label>Strength (e.g., 300mg)</label>
                <input type="text" value={med.strength} onChange={(e) => handleMedicationChange(index, 'strength', e.target.value)} placeholder="e.g. 300mg" />
              </div>
              {index > 0 && (
                <button type="button" className="button white mt-2" onClick={() => removeMedication(med.id)}>Remove</button>
              )}
            </div>
          ))}
          <button type="button" className="button blue" onClick={addMedication}>+ Add Another Medication</button>
          <h3 className="mt-5">Pharmacy:</h3>
          <div className="form-row">
            <label>
              <input type="radio" name="pharmacy" value="file" checked={formData.pharmacy === 'file'} onChange={handleInput} />
              Pharmacy on file
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input type="radio" name="pharmacy" value="different" checked={formData.pharmacy === 'different'} onChange={handleInput} />
              A different pharmacy
            </label>
          </div>

          {formData.pharmacy === 'different' && (
            <>
              <div className="form-row">
                <label>
                  <input type="radio" name="pharmacyType" value="local" checked={formData.pharmacyType === 'local'} onChange={handleInput} />
                  Local Pharmacy
                </label>
                <label style={{ marginLeft: '20px' }}>
                  <input type="radio" name="pharmacyType" value="mail" checked={formData.pharmacyType === 'mail'} onChange={handleInput} />
                  Mail Order Pharmacy
                </label>
              </div>

              {formData.pharmacyType === 'local' && (
                <>
                  <div className="form-row">
                    <label>Select Local Pharmacy</label>
                    <select name="localPharmacy" value={formData.localPharmacy} onChange={handleInput} className="form-control">
                      <option value="">Select</option>
                      <option value="CVS">CVS</option>
                      <option value="Walgreens">Walgreens</option>
                      <option value="Fry's">Fry's</option>
                      <option value="Costco">Costco</option>
                      <option value="Sam's Club">Sam's Club</option>
                      <option value="Target">Target</option>
                      <option value="Walmart">Walmart</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  {formData.localPharmacy === 'Other' && (
                    <div className="form-row">
                      <label>Other Local Pharmacy Name</label>
                      <input type="text" name="otherLocalPharmacy" value={formData.otherLocalPharmacy} onChange={handleInput} />
                    </div>
                  )}
                  <div className="form-row">
                    <label>Crossroads of pharmacy location</label>
                    <input type="text" name="pharmacyCrossRoads" value={formData.pharmacyCrossRoads} onChange={handleInput} />
                  </div>
                </>
              )}

              {formData.pharmacyType === 'mail' && (
                <>
                  <div className="form-row">
                    <label>Select Mail Order Pharmacy</label>
                    <select name="mailOrderPharmacy" value={formData.mailOrderPharmacy} onChange={handleInput} className="form-control">
                      <option value="">Select</option>
                      <option value="Express Scripts">Express Scripts</option>
                      <option value="OptumRx">OptumRx</option>
                      <option value="CVS/Caremark">CVS/Caremark</option>
                      <option value="Cigna">Cigna</option>
                      <option value="Walmart">Walmart</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  {formData.mailOrderPharmacy === 'Other' && (
                    <div className="form-row">
                      <label>Other Mail Order Pharmacy Name</label>
                      <input type="text" name="otherMailOrderPharmacy" value={formData.otherMailOrderPharmacy} onChange={handleInput} />
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <h3 className="mt-5">Preferred Contact Method:</h3>
          <div className="form-row">
            <label><input type="radio" name="contact" value="email" checked={formData.contact === 'email'} onChange={handleInput} /> Email</label>
            <label><input type="radio" name="contact" value="phone" checked={formData.contact === 'phone'} onChange={handleInput} /> Phone</label>
          </div>

          {formData.contact === 'email' && (
            <div className="form-row">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleInput} placeholder="you@example.com" />
            </div>
          )}

          {formData.contact === 'phone' && (
            <>
              <div className="form-row">
                <label>Phone Number</label>
                <PatternFormat
                  name="phone"
                  format="(###) ###-####"
                  mask="_"
                  placeholder="(555) 555-5555"
                  value={formData.phone}
                  onValueChange={(values) => setFormData((prev) => ({ ...prev, phone: values.value }))}
                  className="form-control"
                />
              </div>
              <div className="form-row">
                <label>Voicemail Permission</label>
                <label style={{ display: 'block', marginTop: '5px' }}>
                  <input
                    type="radio"
                    name="voicemail"
                    value="Yes, that is ok"
                    checked={formData.voicemail === 'Yes, that is ok'}
                    onChange={handleInput}
                  />
                  {' '}Yes, that is ok
                </label>
                <label style={{ display: 'block', marginTop: '5px' }}>
                  <input
                    type="radio"
                    name="voicemail"
                    value="No, please just say the message is for me and leave Redemption contact name and number."
                    checked={formData.voicemail === 'No, please just say the message is for me and leave Redemption contact name and number.'}
                    onChange={handleInput}
                  />
                  {' '}No, please just say the message is for me and leave Redemption contact name and number.
                </label>
              </div>

            </>
          )}

          <div className="form-row mt-4">
            <input type="submit" value="Submit" />
          </div>
        </form>
      </div>
    </>
  );
}
